module.exports = __webpack_public_path__ + "img/digital-7.7e337807.png";